<template>
    <div>
        <NavigationBar></NavigationBar>
        <MeetingCreate></MeetingCreate>
        <MeetingFilter></MeetingFilter>
        <MeetingList></MeetingList>
        <MeetingEdit></MeetingEdit>
        <MeetingDelete></MeetingDelete>
        <FooterView></FooterView>
    </div>
</template>
<script>
import NavigationBar from '@/components/shared/Navigation-bar.vue';
import MeetingCreate from '@/components/Meeting/Meeting-create.vue';
import MeetingFilter from '@/components/Meeting/Meeting-filter.vue';
import MeetingList from '@/components/Meeting/Meeting-list.vue';
import MeetingEdit from '@/components/Meeting/Meeting-edit.vue';
import MeetingDelete from '@/components/Meeting/Meeting-delete.vue';
import FooterView from '@/components/shared/Footer/Footer-view.vue';

export default {
    name: 'MeetingViews',

    components:{
        NavigationBar,
        MeetingCreate,
        MeetingFilter,
        MeetingList,
        MeetingEdit,
        MeetingDelete,
        FooterView
    }
}
</script>